import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { BasePageComponent } from '@m4u-angular/base/component/BasePageComponent';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { DataSourceCustomAction } from '@m4u-angular/base/datalayer/BaseDataSources';
import { DataLoadOptions } from '@m4u-angular/base/datalayer/DataLoadOptions';
import { BaseEntitiesResponse, BaseEntity, BaseState, CredentialsCheckerMetadata, 
    CredentialExternalInfo, CredentialType, GenericListEntity, SystemCredentialParams } from '@m4u-angular/base/entities/BaseEntities';
import { CredentialActivityEndpoint } from '@m4u-angular/core/endpoints/credential-activity.endpoint';
import { SystemCredentialsEndpoint } from '@m4u-angular/core/endpoints/system-credentials.endpoint';
import { EnumYesNo } from '@m4u-angular/core/framework/sysenums.enum';
import { 
    SystemCredentialsGridComponent 
} from '@m4u-angular/ui/components/general/system-credentials/system-credentials-grid/system-credentials-grid.component';

export class State extends BaseState {
    CredentialTypes: CredentialType[];
    AdditionalInfoMetadata: CredentialsCheckerMetadata;
    SelectedRows: CredentialExternalInfo[] = [];
    CredentialType: number;
    CredentialID: number;
    IsActive: EnumYesNo | undefined = undefined;
    IsPendingWelcome: EnumYesNo | undefined = undefined;
    IsLockedOut: EnumYesNo | undefined = undefined;
    CredentialFilters: GenericListEntity[] = [];
    CredentialFilter: number;
}

@Component({
    providers: ServiceBagServices,
    selector: 'app-notification-dispatch-recipients',
    templateUrl: './notification-dispatch-recipients.component.html',
    styleUrls: ['./notification-dispatch-recipients.component.scss']
})
export class NotificationDispatchRecipientsComponent extends BasePageComponent<BaseEntity, State> {
    @Output() OnSelectionChanged = new EventEmitter<CredentialExternalInfo[]>();
    @ViewChild(SystemCredentialsGridComponent) grid: SystemCredentialsGridComponent;

    get IsAllowPagination() : boolean {
        return !this.State.CredentialFilter;
    }

    constructor(A: ServiceBagService,
        private credentialActivityEndpoint: CredentialActivityEndpoint,
        private systemCredentialEndpoint: SystemCredentialsEndpoint,) {
        super(A, 'NotificationDispatchRecipientsComponent', BaseEntity, State);
    }

    protected override OnInitComponent() {
        this.LoadSystemCredentials();

        this.Do(this.credentialActivityEndpoint.ListCredentialTypes(), false, (response) => {
            this.State.CredentialTypes = response.Entities;
        });

        this.Do(this.systemCredentialEndpoint.GetAdditionalInfoMetadata(), false, (response) => {
            this.State.AdditionalInfoMetadata = response.Data;
        });

        this.Do(
            this.systemCredentialEndpoint.GetAvailableCredentialFilters(), 
            false, 
            (response: BaseEntitiesResponse<GenericListEntity>) => {
                this.State.CredentialFilters = response.Entities ?? [];
            }
        );
    }

    OnFilterChanged() {
        this.grid.G.gridAny?.instance?.getScrollable()?.scrollTo({ top: 0 });
        this.LoadSystemCredentials();
    }

    OnCredentialsSelectionChanged(credentials: CredentialExternalInfo[]) {
        this.OnSelectionChanged.emit(credentials);
    }

    private LoadSystemCredentials() {
        this.DataSources['SystemCredentials'] = new DataSourceCustomAction((options: DataLoadOptions) => {
            const request = new SystemCredentialParams();
            request.CredentialType = this.State.CredentialType;
            request.CredentialID = this.State.CredentialID;
            request.IsActive = this.ToRequestBoolParam(this.State.IsActive);
            request.IsPendingWelcome = this.ToRequestBoolParam(this.State.IsPendingWelcome);
            request.IsLockedOut = this.ToRequestBoolParam(this.State.IsLockedOut);
            request.CredentialFilter = this.State.CredentialFilter;
            return this.systemCredentialEndpoint.ListSystemCredentials(request, options);
        }, undefined, undefined, !this.IsAllowPagination);

        this.DS['SystemCredentials']?.Reload();
    }

    private ToRequestBoolParam(value: EnumYesNo | undefined) {
        if(value) {
            return value === EnumYesNo.Yes;
        }

        return undefined;
    }
}